import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import { withRadium, DetectCompact } from "higher-order-components"
import gtmHandler from "AtomicUtils/gtmHandler"
import { CloseButton } from "components"
import { Portal } from "react-portal"

/* Overlay Component. */
class GlobalNavOverlay extends PureComponent {
  getHeightStyles = () => {
    const { compact, subNav, active } = this.props

    if (subNav && active && !compact) return { height: "100%", transition: "none" }
    if (subNav && !active) return { height: 0, transition: ".25s" }

    return {}
  }
  handleClose = () => {
    const { gtm } = this.props
    if (gtm && gtm.category) {
      gtmHandler({
        pageCategory: gtm.category,
        pageAction: gtm.action
      })
    }
    this.props.close()
  }
  /**
   * @param {object} event - keyDown event
   */
  handleKeyDown = (event) => {
    if (event.key === "Escape") this.handleClose(event)
  }
  /**
   * @param {Array|FlexContent} components - Nested Components
   * @returns {ReactElement} React Component
   */
  render() {
    return this.props.active ? (
      <Portal>
        <ol
          data-test={"global-nav-overlay"}
          style={[
            styles.ol,
            this.props.subNav
              ? subNavStyles.ol(this.props.compact)
              : topNavStyles.ol(this.props.height, this.props.compact),
            this.getHeightStyles()
          ]}
          onKeyDown={this.handleKeyDown}>
          {!this.props.subNav ? <CloseButton onClick={this.handleClose} /> : ""}
          {React.Children.map(this.props.children, (component, index) =>
            React.cloneElement(component, {
              key: index,
              active: this.props.active,
              subNav: this.props.subNav,
              nav: this.props.nav
            }))}
        </ol>
      </Portal>
    ) : null
  }
}

GlobalNavOverlay.propTypes = {
  active: PropTypes.bool.isRequired,
  subNav: PropTypes.bool,
  nav: PropTypes.bool,
  close: PropTypes.func,
  height: PropTypes.number,
  compact: PropTypes.bool
}

export default withRadium(DetectCompact())(GlobalNavOverlay)

const styles = {
  ol: {
    display: "flex",
    flexWrap: "wrap",
    zIndex: 50,
    listStyle: "none",
    padding: 0,
    margin: 0,
    color: "#212121",
    width: "100%",
    maxHeight: "100%",
    overflowY: "scroll",
    overflowX: "none",
    WebkitOverflowScrolling: "touch"
  }
}

const subNavStyles = {
  ol: compact => ({
    position: compact ? "relative" : "absolute",
    background: "#e6e6e6",
    ...(compact
      ? {}
      : {
        top: 0,
        left: "40vw"
      })
  })
}

const topNavStyles = {
  closed: {
    visibility: "hidden",
    display: "none",
    opacity: 0
  },
  open: {
    visibility: "visible",
    transition: "opacity .5s",
    display: "flex",
    opacity: 1
  },
  ol: (height, compact) => ({
    position: "fixed",
    background: "#dedede",
    width: "100vw",
    ...(height ? { height: `calc(${compact?'100%':'100vh'} - ${height}px)`, top: height } : {})
  })
}



// WEBPACK FOOTER //
// ./src/components/global-nav-overlay/index.jsx